// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 1V23H1V1H23ZM9 7V5H7V7H5V9H7V11H9V9H11V7H9ZM19 7H13V9H19V7ZM8 14.5858L6.58594 13.1717L5.17172 14.5859L6.58579 16L5.17142 17.4144L6.58563 18.8286L8 17.4142L9.41436 18.8286L10.8286 17.4144L9.41421 16L10.8283 14.5859L9.41406 13.1717L8 14.5858ZM19 13.5H13V15.5H19V13.5ZM19 16.5H13V18.5H19V16.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-calculation-1-filled')
export default class Calculation1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'calculation-1-filled',
    }
  }
}
